import httpClient from '@/api/index';

export default {
    getProvinsiOptions: function (params) {
        return httpClient().get('/json/provinsi_options?searchJoin=and&search=' + params.join(';'));
    },
    getKabupatenKotaOptions: function (params) {
        return httpClient().get('/json/kabupaten_kota_options?searchJoin=and&search=' + params.join(';'));
    },
}
